import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/external-authentication')({
  beforeLoad: () => getTitleContextSlice('External Authentication'),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
